module.exports = __webpack_public_path__ + "img/pause-at-work.87c3bbdb.svg";